import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { BasicForm } from "@components/shared";
import countries from "@lib/countries";
import usStates from "@lib/usStates";

export default function GeospotForm({
  name = "",
  address1 = "",
  address2 = "",
  city = "",
  state = "",
  id = null,
  zip = "",
  country = "",
  locationId = null,
  onSuccess = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    const formatted = {
      ...formData,
      state_province: formData.state,
    };

    setLoading(true);

    if (!id) return onCreate(formatted);

    return onUpdate(formatted);
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      geo_spot_id: id,
    };

    axios
      .put(`/geo-spots/${id}/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t("common:updated") + "!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onCreate(formData) {
    const req = {
      ...formData,
      location_id: locationId,
    };

    axios
      .post(`/geo-spots/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t("common:created") + "!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("common:name"),
      initialValue: name,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "address_1",
      label: t("common:address"),
      initialValue: address1,
      addressLookup: true,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "address_2",
      label: t("common:address_line_2"),
      initialValue: address2,
      schema: () => null,
    },
    {
      name: "city",
      label: t("common:city"),
      initialValue: city,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "state",
      label: t("common:state"),
      initialValue: state,
      select: true,
      options: usStates,
      required: true,
      schema: () => Yup.string().nullable().required(t("validation:required")),
    },
    {
      name: "zip",
      label: t("common:zip"),
      initialValue: zip,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "country",
      label: t("common:country"),
      initialValue: country,
      select: true,
      options: countries,
      required: true,
      schema: () => Yup.string().nullable().required(t("validation:required")),
    },
  ];

  return (
    <div>
      <BasicForm
        buttonProps={{
          fullWidth: true,
        }}
        loading={loading}
        onSubmit={onSubmit}
        fields={fields}
      />
    </div>
  );
}
